import {create} from 'zustand';

export interface DashboardTab {
  label: string;
  value: string;
}

interface TabsStore {
  loading: boolean;
  tabs: DashboardTab[];
  activeTab: string;

  setActiveTab: (activeTab: string) => void;
  setIsLoading: (loading: boolean) => void;
  setTabs: (tabs: DashboardTab[]) => void;
}

export const useDashboardTabsStore = create<TabsStore>((set) => ({
  loading: true,
  tabs: [],
  activeTab: '',

  setActiveTab: (activeTab) => set({activeTab}),
  setIsLoading: (loading) => set({loading}),
  setTabs: (tabs) => set({tabs}),
}));
